import React from 'react'
import {
  useResponsiveWrapperContext, ResponsiveBox,
} from '@usap/uicomponents'
import { TextWithPointer } from '@usap/widgets'

export default function NotifyMeLabel({ widgetName }) {
  const { isDesktop } = useResponsiveWrapperContext();

  return (
    <ResponsiveBox
      fxDirection={{ large: 'row', other: 'column' }}
      fxJustify={{ large: 'center', other: 'left' }}
      fxAlign={{ large: 'center', other: 'left' }}
      gap="small"
    >
      {widgetName !== 'Recommendation' && (
        <TextWithPointer
          color="dark-2"
          fxSize={{ large: 'small', other: 'medium' }}
        >
          {isDesktop ? '[Sold Out]' : 'Sold Out'}
        </TextWithPointer>
      )}
      <TextWithPointer
        color='blueLink'
        fxSize={{ large: 'small', other: '13px' }}
      >
        Notify me when available
      </TextWithPointer>
    </ResponsiveBox>
  )
}
